module.exports = __webpack_public_path__ + "static/media/14.14a7f681.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/14.png
// module id = 696
// module chunks = 0